const awards = [
  {
    id: 1,
    title: "JunctionX Seoul 2021 SI Analytics 3rd Winner",
    date: "21 - 23 of May, 2021",
    image: "junction2021.jpg",
    description:
      "3rd place in Satellite Image Analysis track with AI-powered web application able to track changes in the urban landscape",
  },
  {
    id: 2,
    title: "IEEE Seoul Section Student Paper Contest Bronze Award",
    date: "12th of December, 2020",
    image: "IEEE_diploma.png",
    description:
      "For paper «The Optimal Operation of Energy Storage System with Distributed Generators by Using Data-based Prediction Method»",
  },
  {
    id: 3,
    title: "JunctionX Seoul 2020 SI Analytics 3rd Winner",
    date: "9 - 11th of October, 2020",
    image: "junction2020.jpg",
    description:
      "3rd place in Satellite Image Analysis track with project natural disaster tracker SmartMonitor",
  },
  {
    id: 4,
    title:
      "52nd KIEE Summer Conference 2021 Graduate Students Outstanding Paper Award",
    date: "14 - 17th of July, 2021",
    image: "2021_KIEE_Award.png",
    description: "Excellence Prize",
  },
];

export default awards;
